(function () {
  'use strict';

  function initSection(root) {
    if (root.__hdInit) return;
    root.__hdInit = true;

    var tabBtns = root.querySelectorAll('[data-hd-tab]');
    var panels = root.querySelectorAll('[data-hd-panel]');
    var tabList = root.querySelector('.hd-tabs');

    function activateTab(btn) {
      if (!btn) return;
      var targetId = btn.getAttribute('data-hd-tab');

      tabBtns.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');

      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.id === targetId);
      });

      if (tabList && typeof btn.scrollIntoView === 'function') {
        btn.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      }
    }

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateTab(btn);
      });
    });

    var accStack = root.querySelector('.hd-acc-stack');
    var accItems = accStack
      ? accStack.querySelectorAll('[data-hd-acc]')
      : root.querySelectorAll('[data-hd-acc]');

    function setAccOpen(acc, open) {
      if (!acc) return;
      acc.classList.toggle('is-open', open);
      var toggle = acc.querySelector('[data-hd-acc-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeAllAccordions(except) {
      accItems.forEach(function (item) {
        if (item !== except) setAccOpen(item, false);
      });
    }

    // Mobile: keep exactly one accordion open (first by default).
    if (accItems.length) {
      var openItem = null;
      accItems.forEach(function (item) {
        if (!openItem && item.classList.contains('is-open')) openItem = item;
      });
      if (!openItem) openItem = accItems[0];
      closeAllAccordions();
      setAccOpen(openItem, true);
    }

    if (accStack) {
      accStack.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-hd-acc-toggle]');
        if (!btn || !accStack.contains(btn)) return;
        event.preventDefault();
        var acc = btn.closest('[data-hd-acc]');
        if (!acc) return;
        var wasOpen = acc.classList.contains('is-open');
        closeAllAccordions();
        if (!wasOpen) setAccOpen(acc, true);
      });
    }

    var itemsGrid = root.querySelector('#hd-itemsGrid-' + root.getAttribute('data-section-id'));
    var carNav = root.querySelector('[data-hd-carousel-nav]');
    if (itemsGrid && carNav) {
      var prevBtn = carNav.querySelector('[data-hd-car-prev]');
      var nextBtn = carNav.querySelector('[data-hd-car-next]');
      var fill = carNav.querySelector('[data-hd-car-fill]');
      var count = carNav.querySelector('[data-hd-car-count]');

      function getCards() {
        return Array.prototype.slice.call(itemsGrid.querySelectorAll('.hd-item'));
      }

      function updateCarousel() {
        var cards = getCards();
        if (!cards.length) return;
        var scrollLeft = itemsGrid.scrollLeft;
        var cardWidth = cards[0].offsetWidth + 12;
        var idx = Math.round(scrollLeft / cardWidth);
        var max = cards.length - 1;
        idx = Math.max(0, Math.min(idx, max));
        if (prevBtn) prevBtn.disabled = idx <= 0;
        if (nextBtn) nextBtn.disabled = idx >= max;
        if (fill) fill.style.width = ((idx + 1) / cards.length * 100) + '%';
        if (count) count.textContent = (idx + 1) + ' / ' + cards.length;
      }

      itemsGrid.addEventListener('scroll', updateCarousel, { passive: true });
      updateCarousel();

      if (prevBtn) prevBtn.addEventListener('click', function () {
        var cards = getCards();
        if (!cards.length) return;
        var cardWidth = cards[0].offsetWidth + 12;
        itemsGrid.scrollBy({ left: -cardWidth, behavior: 'smooth' });
      });

      if (nextBtn) nextBtn.addEventListener('click', function () {
        var cards = getCards();
        if (!cards.length) return;
        var cardWidth = cards[0].offsetWidth + 12;
        itemsGrid.scrollBy({ left: cardWidth, behavior: 'smooth' });
      });
    }

    var accordionBtns = root.querySelectorAll('[data-hd-accordion]');
    accordionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('.hd-abr');
        if (row) row.classList.toggle('is-open');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.hd-wrap').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var wrap = e.target.querySelector('.hd-wrap');
    if (wrap) {
      wrap.__hdInit = false;
      initSection(wrap);
    }
  });
})();
